import { render, staticRenderFns } from "./business-card.vue?vue&type=template&id=ec670a96&scoped=true&"
import script from "./business-card.vue?vue&type=script&lang=js&"
export * from "./business-card.vue?vue&type=script&lang=js&"
import style0 from "./business-card.vue?vue&type=style&index=0&id=ec670a96&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec670a96",
  null
  
)

export default component.exports